export enum Colors {
  baseBackground = 'Base-background',
  baseSecondaryBackground = 'Base-secondary-background',
  baseSectionBackground = 'Base-section-background',
  lineSecondary = 'Line-secondary',
  baseBubbleBackground = 'Base-bubble-background',
  textTitle = 'Text-title',
  textSubtitle = 'Text-subtitle',
  basePersonaBackground = 'Base-persona-background',
  baseIconBackground = 'Base-icon-background',
  textTextPrimary = 'Text-Text-primary',
  linePrimary = 'Line-primary',
  baseAccentDisabled = 'Base-accent-disabled',
  lineHover = 'Line-hover',
  textHint = 'Text-hint',
  textPrimaryHint = 'Text-primary-hint',
  lineActive = 'Line-active',
  lineError = 'Line-error',
  textError = 'Text-error',
  baseHover = 'Base-hover',
  brandPrimary = 'Brand-primary',
  textBtnPrimary = 'Text-btn-primary',
  textLinkColor = 'Text-link-color',
  brandPremium = 'Brand-premium',
  baseAccentSecondary = 'Base-accent-secondary',
  brandPremiumSecondary = 'Brand-premium-secondary',
  brandSecondary = 'Brand-secondary',
  gradTheme1 = 'Grad-theme-1',
  gradTheme2 = 'grad-theme-2',
  gradTheme3 = 'grad-theme-3',
  gradTheme4 = 'grad-theme-4',
  brandPrimaryAlt = 'Brand-Primary',
  defaultFont = 'Default-Font',
  neutralBorder = 'Neutral-Border',
}
